export default __webpack_public_path__ + "static/media/IdentityGuard-logo.f38138d2.png";